import { Skeleton } from '@mui/lab';

export default function BaseTitoloSkeleton() {
    return (
        <Skeleton width={250} height={50} />
    )
}